import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { PAGE_PROPERTY_NAMES } from '../constants/propertyNames';
import { ScopeNameToId } from '../constants/scopes';
const DEFAULT_OPTIONS = {
  offset: 0,
  count: 1
};
const REQUIRED_FILTERS = [{
  property: PAGE_PROPERTY_NAMES.AB_STATUS,
  operator: 'NOT_IN',
  values: ['mab_variant', 'variant', 'loser_variant']
}, {
  property: CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID,
  operator: 'NOT_HAS_PROPERTY'
}];
const fetchPages = (contentObjectType, filters) => {
  const options = Object.assign({}, DEFAULT_OPTIONS, {
    filterGroups: [{
      filters: [...REQUIRED_FILTERS, ...filters]
    }]
  });
  return http.post(`content-management/search/v1/${contentObjectType}`, {
    data: options
  }).then(({
    total
  }) => total);
};
const fetchScopeChange = ({
  scopeName
}) => {
  const scopeId = ScopeNameToId[scopeName];
  return http.get(`hubs/v2/scope-changes/hub/${PortalIdParser.get()}/scope/${scopeId}/status`);
};
const ScopeChangeInfoQuery = registerQuery({
  fieldName: 'scopeChangeInfo',
  args: ['scopeName', 'contentObjectType', 'filters', 'viewMode'],
  fetcher: ({
    scopeName,
    contentObjectType,
    filters,
    viewMode
  }) => {
    if (viewMode === 'DETAIL') {
      return fetchScopeChange({
        scopeName
      }).then(response => Object.assign({}, response, {
        count: 0
      }));
    }
    return Promise.all([fetchScopeChange({
      scopeName
    }), fetchPages(contentObjectType, filters)]).then(([scopeChangeResponse, countToUnpublishResponse]) => {
      return Object.assign({}, scopeChangeResponse, {
        count: countToUnpublishResponse
      });
    }).catch(err => {
      Raven.captureMessage('Failed to fetch scope change info', {
        extra: {
          scopeName,
          contentObjectType,
          viewMode,
          message: err.message,
          status: err.status
        }
      });
      return {
        count: 0,
        status: 'NOT_PURGED',
        purgedTime: null
      };
    });
  }
});
const useFetchScopeChangeInfo = ({
  scopeName,
  contentObjectType,
  filters,
  viewMode = 'LIST',
  skip
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(ScopeChangeInfoQuery, {
    variables: {
      scopeName,
      contentObjectType,
      filters,
      viewMode
    },
    skip
  });
  return useMemo(() => {
    return {
      scopeChangeInfo: data === null || data === void 0 ? void 0 : data.scopeChangeInfo,
      loading,
      error
    };
  }, [data, loading, error]);
};
export default useFetchScopeChangeInfo;